'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useLocalePath } from '@/hooks/use-locale';

/**
 * "Nicht genug Guthaben — Guthaben aufladen": the one message every alert
 * create/resume/upgrade shows when the backend answers 402. The action goes
 * to /plans, where credits are topped up (1 € / 100 credits).
 */
export function useInsufficientCreditsToast() {
  const { t } = useTranslation();
  const router = useRouter();
  const localePath = useLocalePath();
  return useCallback(
    (needed?: number | null) => {
      toast.error(t('alerts.insufficient.title'), {
        position: 'top-center',
        description:
          typeof needed === 'number' && needed > 0
            ? t('alerts.insufficient.needed', { count: needed })
            : undefined,
        action: {
          label: t('alerts.insufficient.cta'),
          onClick: () => router.push(localePath('/plans')),
        },
      });
    },
    [t, router, localePath],
  );
}
